module.exports = __webpack_public_path__ + "p.no1.14ccab93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/p.no1.jpg
// module id = Qqja
// module chunks = 0